module.exports = __webpack_public_path__ + "static/img/1.42cd1ee3.png";